export const AppInitPhase = {
  Idle: 'idle',
  BlockedUnverified: 'blocked-unverified',
  LoadingAppData: 'loading-app-data',
  RunningOnboarding: 'running-onboarding',
  Ready: 'ready',
  Failed: 'failed',
} as const

export type AppInitPhase = (typeof AppInitPhase)[keyof typeof AppInitPhase]
